import React from 'react'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'
import MemberSummary from './member-summary'
import { Link } from 'react-router-dom'

const FeaturedMember = styled(({ member, ...props }) => {
  const {
    slug,
    title: { rendered: name },
    acf: { job_title: jobTitle, picture }
  } = member
  return <div {...props}>
    <div css='display: flex; flex-direction: column; align-items: center;'>
      <MemberSummary name={name} slug={slug} jobTitle={jobTitle} picture={picture} hideText />
      <Description>
        <span css={`color: ${inheritPrimaryColor}; font-weight: bold`}>Prof. Serena Nik-Zainal</span> is a CRUK Advanced Clinician Scientist and an Honorary Consultant in
        Clinical Genetics. Since her PhD in 2009,
        during which she uncovered genome-wide mutational signatures in breast cancer
        using whole genome sequencing, Serena has continued to develop particular
        expertise in the analysis and interpretation of whole genome sequenced tumours.
        Serena now leads a growing
        and diverse team of researchers, clinicians, students and software developers
        devoted to studying mutational signatures and their implications in cancer,
        combining computational approaches with experimental and cancer data.
        <br /><Link to={`/team/${slug}`} children="Click to see Serena's full bio and contact information" />
      </Description>
    </div>
    {/* <Line /> */}
  </div>
})`width: 100%; max-width: 1140px; margin-bottom: 50px;`

const Description = styled.p`
  font-size: 1.15em;
  line-height: 1.7em;
  color: grey;
  max-width: 800px;
`

const Line = styled.div`
  height: 3px;
  background-image: linear-gradient(0.25turn, white, white, ${inheritPrimaryColor}, white, white);
`

export default FeaturedMember